import { usePageMeta } from "@/hooks/usePageMeta";

export default function PrivacyPolicyPage() {
  usePageMeta("Privacy Policy", "Vaana BuildLogic Technologies values your privacy. We comply with data protection laws and ensure secure handling of all client information.");
  return (
    <div data-testid="privacy-policy-page" className="pt-20">
      <section className="bg-[#0D72B8] py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-20">
          <h1 className="text-4xl sm:text-5xl font-['Sora'] font-bold text-white">Privacy Policy</h1>
          <p className="text-blue-100 mt-4">Last updated: December 2025</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-20 prose-custom">
          <h2>1. Introduction</h2>
          <p>Vaana BuildLogic Technologies ("we", "our", "us") is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>

          <h2>2. Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect the following personal information when you submit an enquiry or contact us:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Service interests</li>
            <li>Message content</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>When you visit our website, we may automatically collect certain information including:</p>
          <ul>
            <li>IP address and browser type</li>
            <li>Device information and operating system</li>
            <li>Pages visited and time spent on each page</li>
            <li>Referring website address</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information for the following purposes:</p>
          <ul>
            <li>To respond to your enquiries and provide requested services</li>
            <li>To communicate with you about our services and offerings</li>
            <li>To improve our website and user experience</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and prevent misuse</li>
          </ul>

          <h2>4. Data Sharing and Disclosure</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
          <ul>
            <li>Service providers who assist us in operating our website and delivering services</li>
            <li>Law enforcement or regulatory authorities when required by law</li>
            <li>Professional advisors including lawyers, auditors, and insurers</li>
          </ul>

          <h2>5. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.</p>

          <h2>6. Data Retention</h2>
          <p>We retain your personal information only for as long as necessary to fulfil the purposes for which it was collected, including to satisfy any legal, accounting, or reporting requirements.</p>

          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to processing of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <h2>8. Cookies</h2>
          <p>Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can set your browser to refuse all or some cookies, or to alert you when websites set or access cookies.</p>

          <h2>9. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policy of every website you visit.</p>

          <h2>10. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.</p>

          <h2>11. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
          <ul>
            <li><strong>Email:</strong> info@vaanabuildlogictechnologies.com</li>
            <li><strong>Phone:</strong> +91 9953167073</li>
            <li><strong>Address:</strong> Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station, New Delhi 110044</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
